import React, { useEffect, useState } from "react";
import style from "./createReport.module.scss";
import Card from "../createReport/preMadeReportCard/preMadeReportCard"
import { Inventory, Pricing, productInfo, RobotData, } from "../../../helpers/consts/reportConsts"
import Input from "../../input/input"
import Button from "../../Button/button"
import Checkbox from "../../SelectionControls/Checkbox/Checkbox"
import RangeDropdown from "../../Dropdown/rangeDropdown/rangeDropdown"
import LightDropdown from "../../Dropdown/lightButtonDropdown/lightButtonDropdown"
import { CreateReports, EditReport, GetList, GetReportFilterRange, GetReportList } from "../../../actions/APIcalls"
import Modal from "../../Modal/Modal"
import { withRouter, Link } from "react-router-dom"
import GradientToast from "../../gradientToast/Toast"

const CreateReport = (props) => {
    const [reportSelectors, setReportSelector] = useState(
        {
            reportName: "", nameError: "", selectAll: false,
        })
    const [recentReports, setRecentReports] = useState([])
    const [selectedCheckbox, setSelectedCheckbox] = useState({})
    const [selectedFilters, setSelectedFilters] = useState({})
    const [defaultRanges, setDefaultRanges] = useState({})
    const [createReportLoading, setCreateReportLoading] = useState(false)
    //life Cycles*********************************************
    useEffect(() => {
        let obj = {
            channel: true,
            brand: true,
            DKP: true,
            DKPC: true,
            productName: true,
            productNewName: true,
            productGroup: true,
            supplierCode: true
        }
        setSelectedCheckbox({ ...obj })
        getBrands()
        getProductGroup()
        getSellers()
        getReportList()
    }, [])
    useEffect(() => {
        if (typeof props.location.state !== "undefined" && typeof props.location.state.id !== "undefined" && typeof props.location.state.report !== "undefined") {
            let selected = {}
            let selectors = reportSelectors;
            selectors.reportName = props.location.state.report.reportName;
            setReportSelector({ ...selectors })
            setSelectedCheckbox({ ...props.location.state.report.show })
            Object.keys(props.location.state.report.show).forEach(async item => {
                if (typeof props.location.state.report[item] !== "undefined" && props.location.state.report[item]) {
                    if (typeof props.location.state.report[item].from === "undefined") {
                        if (item == 'channel' && !Array.isArray(props.location.state.report[item])) {
                            selected[item] = [props.location.state.report[item]]
                        } else {
                            selected[item] = props.location.state.report[item]
                        }
                        setSelectedFilters({ ...selected })
                    } else {
                        await getRange(item)
                        selected[item] = props.location.state.report[item]
                        setSelectedFilters({ ...selected })
                    }
                }
            })
            setSelectedFilters({ ...selected })

        }
    }, [props.location])
    //server call*********************************************
    const createNewReport = async () => {
        if (reportSelectors.reportName == "") {
            setReportSelector({ reportName: "", nameError: "نام گزارش را وارد کنید" })
        } else {
            let params = {
                reportName: reportSelectors.reportName,
                report: {
                    ...selectedFilters,
                    show: {
                        ...selectedCheckbox
                    }
                }
            }
            setCreateReportLoading(true)
            let res = await CreateReports(params)
            if (res) {
                setCreateReportLoading(false)
                let temp = reportSelectors;
                temp.reportName = ""
                temp.nameError = ""
                temp.modalShow = false
                temp.selectAll = false
                setReportSelector({ ...temp })
                let obj = {
                    channel: true,
                    brand: true,
                    DKP: true,
                    DKPC: true,
                    productName: true,
                    productNewName: true,
                    productGroup: true,
                    supplierCode: true
                }
                setSelectedCheckbox({ ...obj })
                setSelectedFilters({})
                props.history.push({ pathname: "/report/show/" + res.data.id._id, state: { report: { ...res.data.id } } })

            }

        }
    }
    const editReport = async () => {
        let params = {
            id: props.location.state.id,
            report: {
                ...selectedFilters,
                show: {
                    ...selectedCheckbox
                }
            }
        }
        Object.keys(selectedFilters).forEach(item => {
            params.report[item] = selectedFilters[item]
        })
        params.report.reportName = reportSelectors.reportName
        let res = await EditReport(params)
        if (res) {
            props.history.push("/report/reportList")
        }
    }
    const getProductGroup = async () => {
        let res = await GetList("v1/product/GroupList");
        let temp = [];
        if (res) {
            let reportSelector = reportSelectors
            res.GroupList.forEach(item => {
                let obj = {
                    name: item,
                    value: item,
                    checked: false
                }
                temp.push(obj)
            })

            reportSelector.productGroup = [...temp]
            reportSelector.mainProductGroup = [...temp]
            setReportSelector({ ...reportSelector })

        }
    }
    const getSellers = async () => {
        let res = await GetList("v1/channel/channelList");
        let temp = [];
        let temp2 = [];
        if (res) {
            let reportSelector = reportSelectors
            res.channelList.forEach(item => {
                let obj = {
                    name: item.name,
                    value: item._id,
                    checked: false
                }
                let obj2 = {
                    data: item,
                    value: item._id,
                    checked: false
                }
                temp.push(obj);
                temp2.push(obj2)

            })
            reportSelector.channel = [...temp]
            reportSelector.mainChannel = [...temp2]
            setReportSelector({ ...reportSelector })
        }
    }
    const getBrands = async () => {
        let res = await GetList("v1/product/brandList");
        let temp = [];
        let reportSelector = reportSelectors
        if (res) {
            res.BrandList.forEach(item => {
                let obj = {
                    name: item,
                    value: item,
                    checked: false
                }
                temp.push(obj);
            })
            reportSelector.brand = [...temp]
            reportSelector.mainBrand = [...temp]
            setReportSelector({ ...reportSelector })
        }
    }

    const getReportList = async () => {
        let params = {
            search: "",
            pageNumber: 4,
            page: 1,
            sort: "_id",
            by: -1
        }
        let res = await GetReportList(params)
        if (typeof res !== "undefined" && typeof res.data !== "undefined") {
            setRecentReports([...res.data.reports])
            window.scrollTo({
                top: 0,
                behavior: "smooth"
            });
        }

    }
    const getRange = async (tag) => {
        let res = await GetReportFilterRange({ field: tag })
        if (typeof res !== "undefined" && res.data.success) {

            let Range = {}
            if (res.data.min <= res.data.max) {
                Range.from = res.data.min !== null ? res.data.min : 0
                Range.to = res.data.max !== null ? res.data.max : 100000000
            } else {
                Range.from = res.data.max !== null ? res.data.max : 0
                Range.to = res.data.min !== null ? res.data.min : 100000000
            }
            let selected = selectedFilters;
            selected[tag] = Range;
            let defaults = defaultRanges
            defaults[tag] = Range
            setDefaultRanges({ ...defaults })
        }
    }
    //handlers************************************************
    const serverDataSetter = (tag, data) => {
        let selected = selectedFilters;
        selected[tag] = data;
        setSelectedFilters({ ...selected })
    }
    const deleteAll = (tag) => {
        let selected = selectedFilters
        delete selected[tag]
        setSelectedFilters({ ...selectedFilters })

    }
    const handleCheckboxDropdown = (tag, item) => {
        let selected = { ...selectedFilters }
        if (typeof selectedFilters[tag] !== "undefined") {
            if (selectedFilters[tag].includes(item.value)) {
                let index = selectedFilters[tag].findIndex(element => element === item.value)
                selected[tag].splice(index, 1)
                setSelectedFilters({ ...selected })
                if (selected[tag].length < 1) {
                    delete selected[tag]
                    setSelectedFilters({ ...selected })
                }
            } else {
                selected[tag].push(item.value)
                setSelectedFilters({ ...selected })
            }
        } else {
            selected[tag] = []
            selected[tag].push(item.value)
            setSelectedFilters({ ...selected })
        }
    }
    const inputHandler = (tag, e) => {
        let data = { ...reportSelectors }
        data.reportName = e.target.value;
        setReportSelector({ ...data })
    }
    const handleCheckboxs = (e, value, tag, secondTag) => {
        let temp = selectedCheckbox;
        if (typeof temp[tag] !== "undefined") {
            delete temp[tag]
            if (reportSelectors.selectAll) {
                let selectors = reportSelectors
                selectors.selectAll = false
                setReportSelector({ ...selectors })
            }
        } else {
            temp[tag] = true
        }
        setSelectedCheckbox({ ...temp })
        if (typeof secondTag !== "undefined" && secondTag == "range") {
            getRange(tag)
        }
    }
    const selectAll = (e, value, tag) => {
        let array = [Pricing, productInfo, Inventory, RobotData]
        let temp = { ...reportSelectors };
        temp.selectAll = !temp.selectAll;
        setReportSelector({ ...temp })
        let selected = selectedCheckbox
        if (!reportSelectors.selectAll) {
            array.forEach(item => {
                item.forEach(element => {
                    selected[element.value] = true
                    if (element.type === 'range') {
                        getRange(element.value)
                    }
                })
            })
            setSelectedCheckbox({ ...selected })
        } else {
            selected = {
                channel: true,
                brand: true,
                DKP: true,
                DKPC: true,
                productName: true,
                productNewName: true,
                productGroup: true,
                supplierCode: true
            }
            // selected=[]
            setSelectedCheckbox({ ...selected })

        }
    }
    const setCreateModal = () => {
        if (typeof props.location.state !== "undefined" && typeof props.location.state.id !== "undefined") {
            editReport()
        } else {
            let temp = { ...reportSelectors };
            if (reportSelectors.reportName.length == 0) {
                temp.nameError = "نام گزارش را وارد کنید"
                setReportSelector({ ...temp })
            }
            if (reportSelectors.reportName.length > 0) {
                temp.nameError = ""
                temp.modalShow = true
                setReportSelector({ ...temp })

            }
        }
    }
    const handleSearch = (tag, val) => {
        switch (tag) {
            case "brand":
                searchDropdown(reportSelectors.mainBrand, val, false, tag)
                break;
            case "productGroup":
                searchDropdown(reportSelectors.mainProductGroup, val, false, tag)
                break;
            case "channel":
                searchDropdown(reportSelectors.mainChannel, val, true, tag)
                break;
            default:
                break;
        }
    }
    //function************************************************
    const searchDropdown = (array, searchKey, type, tag) => {
        //type 0 no data in object 1 has data in object
        let temp = []
        if (!type) {
            array.forEach(item => {
                if (item.name.includes(searchKey)) {
                    temp.push(item)
                }
            });
        } else {
            array.forEach(item => {
                if (item.data.name.includes(searchKey)) {
                    let obj = {
                        name: item.data.name,
                        value: item.data._id,
                        checked: false
                    }
                    temp.push(obj)
                }
            });
        }
        let reportSelector = reportSelectors;
        reportSelector[tag] = [...temp];
        setReportSelector({ ...reportSelector })
    }
    const checkSelectAll = () => {
        let array = [Pricing, productInfo, Inventory, RobotData]
        let selected = selectedCheckbox
        let flag = true
        array.forEach(item => {
            item.forEach(element => {
                if (!selected[element.value]) {
                    flag = false
                }
            })
        })

        return flag
    }
    const findContent = (value) => {
        let res = productInfo.find(item => item.value === value)
        if (res) {
            return res
        }
        let res2 = Pricing.find(item => item.value === value)
        if (res2) {
            return res2
        }
        let res3 = Inventory.find(item => item.value === value)
        if (res3) {
            return res3
        }
        let res4 = RobotData.find(item => item.value === value)
        if (res4) {
            return res4
        }

    }
    const checkIsDefault = () => {
        let flag = true
        Object.keys(selectedFilters).forEach(item => {
            if (typeof selectedFilters[item] !== "undefined" && typeof selectedFilters[item].from !== "undefined" && typeof defaultRanges[item] !== "undefined") {
                if (selectedFilters[item].from !== defaultRanges[item].from || selectedFilters[item].to !== defaultRanges[item].to) {
                    flag = false
                }
            } else if (typeof selectedFilters[item] !== "undefined" && typeof selectedFilters[item].from === "undefined" && selectedFilters[item].length > 0) {
                flag = false
            }
        }
        )
        return flag
    }
    return (
        <div className={style.wrapper}>
            {
                props.user.expiredAccount &&
                <div className={style.gradientWrapper}>
                    <GradientToast tag="test" value={true}>
                        <>
                            <p className={style.expiredTitle}>شارژ کیف پول شما تمام شده‌است.</p>
                            <p className={style.expiredText}>برای فعال‌سازی مجدد ربات، کیف پول خود را شارژ کنید.</p>
                            <Link className={style.expiredLink} to={'/chargewallet'}>ورود به صفحه‌ی  شارژ کیف پول  </Link>
                        </>
                    </GradientToast>
                </div>
            }
            <Modal
                tag="createReport"
                value={reportSelectors.modalShow ? true : false}
                title="ساخت گزارش"
                parentClose={() => {
                    let temp = { ...reportSelectors };
                    temp.modalShow = false;
                    setReportSelector({ ...temp })
                }}>
                <div className={style.modalContent}>
                    <div className={style.text}>
                        آیا از ساخت گزارش
                        <div className={style.bold}>{" " + reportSelectors.reportName + " "}</div>
                        مطمئن هستید؟
                    </div>
                    <div className={style.buttonPack}>
                        < Button
                            disabled={false}
                            tag="createReportCancel"
                            type="outline"
                            label="انصراف"
                            onclick={() => {
                                let temp = { ...reportSelectors };
                                temp.modalShow = false;
                                setReportSelector({ ...temp })
                            }}
                        />
                        < Button
                            disabled={false}
                            tag="createReportConfirm"
                            loading={createReportLoading}
                            type="solid"
                            label="ساخت گزارش"
                            onclick={createNewReport}
                        />

                    </div>
                </div>
            </Modal>
            {typeof props.location.state !== "undefined" && typeof props.location.state.id !== "undefined" && typeof props.location.state.report !== "undefined"
                ? <h1>ویرایش گزارش {props.location.state.report.reportName}</h1> : <h1>ساخت گزارش</h1>}
            <p className={style.p}>.شما می‌توانید گزارش موردنیاز را با فیلدهای موردنظر خود بسازید و برای استفاده‌های
                بعدی خود ذخیره کنید</p>
            {recentReports.length > 0 && <div className={style.defaultReports}>
                <h2>گزارش‌های اخیر شما</h2>
                <div className={style.box}>
                    {recentReports.map((item, index) => {
                        return (<div key={index} className={style.cardWrapper} onClick={() => {
                            props.history.push({ pathname: "/report/show/" + item._id, state: { report: { ...item } } })
                        }}>
                            <Card title={item.reportName} text={item.text}
                                date={typeof item.createDate !== "undefined" && item.createDate}
                                data={{ ...item.show }} />
                        </div>)
                    })}
                </div>
            </div>}
            <h2>مشخصات گزارش</h2>
            <div className={style.reportProperties}>
                <div className={style.inputWrapper}>
                    <Input
                        label="نام گزارش"
                        type="text"
                        disabled={false}
                        placeholder="مثال: کالاهای پرسود"
                        tag="reportName"
                        error={reportSelectors.nameError}
                        value={reportSelectors.reportName}
                        onchange={inputHandler}
                        onblur={() => {
                        }}
                    />
                </div>
                {/* <div className={style.calendarHolder}>
                < DatePicker
                  tag="date"
                  date={serverDataSetter}
                  error={reportSelectors.dateError && reportSelectors.dateError}
                 />
                 
                </div> */}
            </div>
            <h2>انتخاب فیلدهای موردنظر</h2>
            <div className={style.row}>
                <div className={style.checkboxContainer}>
                    <Checkbox
                        value={checkSelectAll()}
                        indeterminate={false}
                        disabled={false}
                        tag='all'
                        label='همه‌ی موارد'
                        onclick={selectAll}
                    />
                </div>
            </div>
            <h3>اطلاعات کالا</h3>
            <div className={style.checkboxRow}>
                {
                    productInfo.map((item, index) => {
                        return (
                            <div key={index} className={style.checkboxContainer}>
                                <Checkbox
                                    value={typeof item.required !== "undefined" ? true : (typeof selectedCheckbox[item.value] !== "undefined" ? true : false)}
                                    indeterminate={false}
                                    disabled={typeof item.required !== "undefined" && true}
                                    tag={item.value}
                                    label={item.name}
                                    secondTag={item.type}
                                    onclick={handleCheckboxs}
                                />
                            </div>
                        )
                    })
                }
            </div>
            <h3> قیمت‌گذاری</h3>
            <div className={style.checkboxRow}>
                {
                    Pricing.map((item, index) => {
                        return (
                            <div key={index} className={style.checkboxContainer}>
                                <Checkbox
                                    value={typeof item.required !== "undefined" ? true : (typeof selectedCheckbox[item.value] !== "undefined" ? true : false)}
                                    indeterminate={false}
                                    disabled={typeof item.required !== "undefined" && true}
                                    tag={item.value}
                                    label={item.name}
                                    secondTag={item.type}
                                    onclick={handleCheckboxs}
                                />
                            </div>
                        )
                    })
                }
            </div>
            <h3> انبارداری</h3>
            <div className={style.checkboxRow}>
                {
                    Inventory.map((item, index) => {
                        return (
                            <div key={index} className={style.checkboxContainer}>
                                <Checkbox
                                    value={typeof item.required !== "undefined" ? true : (typeof selectedCheckbox[item.value] !== "undefined" ? true : false)}
                                    indeterminate={false}
                                    disabled={typeof item.required !== "undefined" && true}
                                    tag={item.value}
                                    label={item.name}
                                    secondTag={item.type}
                                    onclick={handleCheckboxs}
                                />
                            </div>
                        )
                    })
                }
            </div>
            <h3> اطلاعات ربات</h3>
            <div className={style.checkboxRow}>
                {
                    RobotData.map((item, index) => {
                        return (
                            <div key={index} className={style.checkboxContainer}>
                                <Checkbox
                                    value={typeof item.required !== "undefined" ? true : (typeof selectedCheckbox[item.value] !== "undefined" ? true : false)}
                                    indeterminate={false}
                                    disabled={typeof item.required !== "undefined" && true}
                                    tag={item.value}
                                    label={item.name}
                                    secondTag={item.type}
                                    onclick={handleCheckboxs}
                                />
                            </div>
                        )
                    })
                }
            </div>
            <h2>تنظیمات فیلترها</h2>
            <div className={style.filtersText}>
                <p>
                    .به‌صورت پیش‌فرض تمام حالات هر فیلد نمایش داده می‌شود
                </p>
                <p>
                    .درصورت نیاز می‌توانید بر روی فیلدهای موردنظر خود فیلتر اعمال کنید
                </p>
            </div>
            {!checkIsDefault() && <div className={style.deleteFilters}>
                <p>
                    <div className={style.icon}>n</div>
                    .فیلترها بر روی فیلدهای مورد نظر اعمال شد
                </p>
                <div className={style.delete} onClick={() => {
                    setSelectedFilters({ ...defaultRanges })
                }}>حذف تمام فیلترها
                </div>

            </div>}
            <div className={style.row}>
                {
                    Object.keys(selectedCheckbox).map((item, index) => {
                        let res = findContent(item)
                        if (typeof res !== "undefined" && typeof res.type !== "undefined" && res.type === "range") {
                            return <div key={index} className={style.dropdownHandler}>
                                <div style={{ width: "217px", marginLeft: "50%" }}>
                                    {typeof defaultRanges[res.value] !== 'undefined' ?
                                        <RangeDropdown
                                            tag={res.value}
                                            value={typeof selectedFilters[res.value] !== "undefined" && selectedFilters[res.value] ? {
                                                from: selectedFilters[res.value].from,
                                                to: selectedFilters[res.value].to
                                            } : undefined}
                                            placeHolder={res.name}
                                            unitLabel={res.unitLabel}
                                            action={() => {
                                            }}
                                            deleteSelectedItems={deleteAll}
                                            setData={serverDataSetter}
                                            defaultRange={defaultRanges[res.value]}
                                            setToDefault={typeof selectedFilters[res.value] !== "undefined" &&
                                                typeof defaultRanges[res.value] !== "undefined" &&
                                                selectedFilters[res.value].from === defaultRanges[res.value].from &&
                                                selectedFilters[res.value].to === defaultRanges[res.value].to
                                                ? true : false}
                                        />
                                        :
                                        null
                                    }

                                </div>
                            </div>
                        }
                        if (typeof res !== "undefined" && typeof res.type !== "undefined" && res.type === "checkbox") {
                            return <div key={index} className={style.dropdownHandler}>
                                <div className={style.button}>
                                    {/* {console.log(selectedFilters[res.value], 'res.value that we pass...')} */}
                                    <LightDropdown
                                        tag={res.value}
                                        dropdownList={res.value === "channel" || res.value === "brand" || res.value === "productGroup" ? reportSelectors[res.value] : res.dropdownContent}
                                        placeHolder={res.name}
                                        handleSelect={handleCheckboxDropdown}
                                        selectedList={typeof selectedFilters[res.value] !== "undefined" ? selectedFilters[res.value] : []}
                                        hasSearchBox={res.value === "channel" || res.value === "brand" || res.value === "productGroup" ? true : false}
                                        handleSearch={handleSearch}
                                        hasCheckbox={true}
                                        action={() => {
                                        }}
                                        deleteSelectedItems={deleteAll}
                                    />
                                </div>
                            </div>
                        }
                        if (typeof res !== "undefined" && typeof res.type !== "undefined" && res.type === "toggle") {
                            return <div key={index} className={style.dropdownHandler}>
                                <div className={style.button}>
                                    <LightDropdown
                                        tag={res.value}
                                        dropdownList={res.dropdownContent}
                                        placeHolder={res.name}
                                        handleSelect={handleCheckboxDropdown}
                                        selectedList={typeof selectedFilters[res.value] !== "undefined" ? selectedFilters[res.value] : []}
                                        hasSearchBox={false}
                                        hasCheckbox={false}
                                        hasToggle={true}
                                        action={() => {
                                        }}
                                        deleteSelectedItems={deleteAll}
                                    />
                                </div>
                            </div>
                        }
                    })
                }
            </div>
            <div className={style.buttonPack}>
                {
                    reportSelectors.nameError || reportSelectors.dateError0 ?
                        <div className={style.error}>
                            {reportSelectors.nameError ? reportSelectors.nameError : '.لطفا فیلدهای مورد نیاز را پر کنید'}
                        </div> : null
                }
                <div className={style.box}>
                    <div className={style.buttonWrapper}>
                        <Button
                            disabled={false}
                            tag="cancel"
                            type="outline"
                            label="انصراف"
                            onclick={() => {
                                props.history.push("/report/reportlist")
                            }} />
                    </div>
                    <div className={style.buttonWrapper}>

                        <Button
                            disabled={false}
                            tag="createReport"
                            type="solid"
                            // isLoading={true}
                            label={typeof props.location.state !== "undefined" && typeof props.location.state.id !== "undefined" ? "ویرایش " : "ساخت گزارش"}
                            onclick={setCreateModal}
                        />
                    </div>
                </div>
            </div>
        </div>
    )

}

export default withRouter(CreateReport);
